import { parseISO } from 'date-fns';

import { parseDateRange } from 'components/shared/DatePicker/functions';
import { EDateFormat } from 'detailsv2/structure';

import { getNumericalFormattedDate, getNumericalFormattedDatesRange } from '../functions';
import { TInputDatePickerProps } from '../type';

export const NumericalDatePlank = function ({
  mode,
  dateFormat,
  input,
}: TInputDatePickerProps & { dateFormat: EDateFormat }) {
  if (!input.value) return null;

  if (mode === 'range') {
    return <span>{getNumericalFormattedDatesRange(parseDateRange(input.value))}</span>;
  }

  return <span>{`${getNumericalFormattedDate(parseISO(input.value), dateFormat)}`}</span>;
};
